import { useEffect } from 'react';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';
import { useConectionSocketAdmConversation } from '../../hooks/useSocketAdmConversations';
import { removeUnAnsweredConversation } from 'store/action/unanswered-convertations-action';
import { removeConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { PlayNewAlert } from './components/Alerts';
import { useSelector } from 'react-redux';
import store from 'store';
import ConfigurationService from '../../views/SystemParams/services';
import { useSocketConversationChatTs } from 'hooks/useSocketConversationChatTs';
import { EVENTS_EMIT } from 'hooks/useSocketConversationChatTs';

const Notification = () => {
  const { socketAdm } = useConectionSocketAdmConversation();
  const { socketConversation } = useConversationConnectionSocketForMonitoring();
  const { socketChatTS } = useSocketConversationChatTs();
  const conversationInAttendance = useSelector(
    (state) => state.conversationInAttendance
  );

  useEffect(() => {
    if (!window.Notification) {
      return;
    }
    window.Notification.requestPermission().then((permission) => {
      return permission;
    });
    // "denied" (o usuário se recusa a ter notificações exibidas),
    // "granted" (o usuário aceita ter notificações exibidas) ou
    // "default" (a escolha do usuário é desconhecido e, portanto, o navegador irá agir como se o valor foram negados).
  }, []);

  useEffect(() => {
    ConfigurationService.getAllConfigs()
      .then((response) => {
        const audioNotification = response.data.audio_chat;

        socketChatTS.on(
          EVENTS_EMIT.SHOW_POPUP_TO_AGENT,
          /**
           * @param {Object} data
           * @param {string} data.message
           * @param {string} data.type
           * @param {boolean} data.playAudio
           * @param {string} data.action
           */
          (data) => {
            if (data?.message && data?.type) {
              let permission = window.Notification.permission;

              if (data.playAudio) {
                PlayNewAlert({
                  data: '__purposefully__mocked__falsy__value__',
                  areDesktopNotificationsAllowed: permission,
                  type: null,
                  audioNotificationURL: audioNotification,
                  isNotificationScheduling: false,
                  message: data.message,
                  toastData: {
                    type: data.type,
                    message: data.message,
                    action: data.action,
                    playAudio: data.playAudio
                  }
                });
              } else {
                PlayNewAlert({
                  data: data.message,
                  areDesktopNotificationsAllowed: permission,
                  audioNotificationURL: audioNotification,
                  isNotificationScheduling: false,
                  playAudio: false,
                  toastData: data
                });
              }
            }
          }
        );

        socketConversation.on('cliente_enviou_mensagem_portal_chat', (data) => {
          let permission = window.Notification.permission;
          let type = 'new_message';
          PlayNewAlert({
            data,
            areDesktopNotificationsAllowed: permission,
            type,
            audioNotificationURL: audioNotification,
            toastData: {
              action: 'NEW_MESSAGE',
              message: 'Nova mensagem recebida',
              type: 'INFO',
              playAudio: true
            }
          });
        });

        socketConversation.on(
          'conversa_transferida_pelo_bot_para_atendente',
          (data) => {
            const attendantLogin = localStorage.getItem('login');
            const { conversa } = data;
            if (
              conversa.atendente.id_postgres === attendantLogin &&
              conversa.atendida
            ) {
              let permission = window.Notification.permission;
              let type = 'exclusiveconversation';
              PlayNewAlert({
                data: conversa,
                areDesktopNotificationsAllowed: permission,
                type,
                audioNotificationURL: audioNotification,
                toastData: {
                  action: 'TRANSFER_CHAT',
                  message: 'Conversa transferida',
                  type: 'INFO',
                  playAudio: true
                }
              });
            }
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, [socketConversation, socketAdm, socketChatTS]);

  useEffect(() => {
    socketAdm.on('conversa_abandonada_cliente', async (data) => {
      if (data.id === conversationInAttendance.conversation._id) {
        await store.dispatch(removeConversationInAttendance());
      }

      await store.dispatch(removeUnAnsweredConversation(data.id));
    });

    return () => socketAdm.off('conversa_abandonada_cliente');
  }, [socketAdm, conversationInAttendance]);

  return null;
};

export default Notification;
